import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

/** Identifier type for public.forecast_model_type_ */
export type ForecastModelTypeId = string & { __brand: 'ForecastModelTypeId' }

/** Represents the table public.forecast_model_type_ */
export default interface ForecastModelTypeTable {
  /** Database type: pg_catalog.text */
  id: ColumnType<ForecastModelTypeId, ForecastModelTypeId, ForecastModelTypeId>

  /** Database type: pg_catalog.text */
  description: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date, Date | string | undefined, Date | string>
}

export type ForecastModelType = Selectable<ForecastModelTypeTable>

export type ForecastModelTypeInitializer = Insertable<ForecastModelTypeTable>

export type ForecastModelTypeMutator = Updateable<ForecastModelTypeTable>

export const forecastModelTypeId =
  z.string() as unknown as z.Schema<ForecastModelTypeId>

export const forecastModelType = z.object({
  id: forecastModelTypeId,
  description: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
}) as unknown as z.Schema<ForecastModelType>

export const forecastModelTypeInitializer = z.object({
  id: forecastModelTypeId,
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<ForecastModelTypeInitializer>

export const forecastModelTypeMutator = z.object({
  id: forecastModelTypeId.optional(),
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<ForecastModelTypeMutator>
